import { createContext, useEffect } from 'react';
import { User } from '../../types/Types';

import AuthHooks from './Auth.hooks';

export const AuthContext = createContext({
  login: (params: any) => {},
  logout: () => {},
  currentUser: {} as User,
  axiosJWT: '' as any,
  accessToken: '',
  userId: '',
});

export function AuthProvider(props: any) {
  const {
    getCurrentUser,
    login,
    logout,
    currentUser,
    axiosJWT,
    accessToken,
    userId,
  } = AuthHooks();

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        currentUser,
        axiosJWT,
        accessToken,
        userId,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}
